import script from "./ApplicantsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicantsView.vue?vue&type=script&setup=true&lang=js"

import "./ApplicantsView.vue?vue&type=style&index=0&id=5e459d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e459d92"]])

export default __exports__